"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.community = void 0;
var env_1 = require("../../env");
exports.community = {
  id: 'community',
  label: 'Community',
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:community'] : null,
  children: [{
    id: 'organisations',
    type: 'list',
    entityTypeName: 'Organisation',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:organisations'] : null
  }, {
    id: 'people',
    type: 'list',
    entityTypeName: 'Person',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:people'] : null
  }, {
    id: 'chapters',
    type: 'list',
    entityTypeName: 'Chapter',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:chapters'] : null
  }]
};